import React from "react"
import styled from "styled-components"
import { useSelector } from "react-redux"
import { Overlay, Tooltip } from "react-bootstrap"
import { StoreType } from "client/store"
import { CrossIcon } from "client/components"


export interface DeleteConfirmProps {
    target: HTMLElement
    show: boolean
    onClose: () => void
}

const tooltipOffset = "4px"
const TooltipStyled = styled(Tooltip)`
    padding-bottom: ${tooltipOffset};

    & > .tooltip-inner {
        padding: 4px 8px;
        border-radius: 4px;
        line-height: 20px;
        font-family: system-ui;
        font-size: ${(props) => props.theme.fontSizes.md}px;
        color: ${(props) => props.theme.tooltipColor};
        background: ${(props) => props.theme.tooltipBackground};
    }

    & > .tooltip-arrow {
        position: absolute;
        display: block;
        width: 12px;
        height: 6px;
        top: calc(100% - ${tooltipOffset});

        &::before {
            position: absolute;
            content: "";
            pointer-events: none;
            border: solid 6px transparent;
            border-bottom: none;
            border-top-color: ${(props) => props.theme.tooltipBackground};
        }
    }
`
const CloseButton = styled.div`
    float: right;
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.xs}px;
        color: ${(props) => props.theme.tooltipCloseColor};
        transition: ${(props) => props.theme.defaultTransition};

        &:hover {
            color: ${(props) => props.theme.tooltipCloseHoverColor};
            transition: ${(props) => props.theme.defaultTransition};
        }
    }
`

export const DeleteConfirm = ({
    target,
    show,
    onClose,
}: DeleteConfirmProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <Overlay target={target} show={show} placement="top">
            <TooltipStyled id="delete-confirm">
                {lang.clickConfirmDelete}
                <CloseButton onClick={onClose}>
                    <CrossIcon />
                </CloseButton>
            </TooltipStyled>
        </Overlay>
    )
}
